const getDefaultState = () => {
  return {
    conversationMessagesList: [],
    prompt: "",
    chatId: null,
    messages: [],
    isDialogOpen: false,
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getConversationMessagesList: (state) => {
      return state.conversationMessagesList;
    },
    getPrompt: (state) => {
      return state.prompt;
    },
    getChatId: (state) => {
      return state.chatId;
    },
    getMessages: (state) => {
      return state.messages;
    },
    getIsDialogOpen: (state) => {
      return state.isDialogOpen;
    },
  },
  mutations: {
    SET_CONVERSATION_MESSAGES_LIST(state, conversationMessagesList) {
      state.conversationMessagesList = conversationMessagesList;
    },
    SET_PROMPT(state, prompt) {
      state.prompt = prompt;
    },
    SET_CHAT_ID(state, chatId) {
      state.chatId = chatId;
    },
    SET_MESSAGES(state, messages) {
      state.messages = messages;
    },
    ADD_MESSAGE(state, message) {
      state.messages.push(message);
    },
    CLEAR_SESSION(state) {
      state.chatId = null;
      state.messages = [];
      state.conversationMessagesList = [];
      state.prompt = "";
    },
    SET_DIALOG_OPEN(state, isOpen) {
      state.isDialogOpen = isOpen;
    },
  },
  actions: {
    setConversationMessagesList({ commit }, conversationMessagesList) {
      commit("SET_CONVERSATION_MESSAGES_LIST", conversationMessagesList);
    },
    setPrompt({ commit }, prompt) {
      commit("SET_PROMPT", prompt);
    },
    setChatId({ commit }, chatId) {
      commit("SET_CHAT_ID", chatId);
    },
    setMessages({ commit }, messages) {
      commit("SET_MESSAGES", messages);
    },
    addMessage({ commit }, message) {
      commit("ADD_MESSAGE", message);
    },
    clearSession({ commit }) {
      commit("CLEAR_SESSION");
    },
    setDialogOpen({ commit }, isOpen) {
      console.log("Setting AI dialog open state to:", isOpen);
      commit("SET_DIALOG_OPEN", isOpen);
    },
  },
};
